module.exports = __webpack_public_path__ + "images/almost-famous-296e3995d8d8acded07284ede180569d.png";